import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable, of, throwError, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthManagementService } from '@core/service/auth-management.service';
import { Router } from '@angular/router';
import { HttpMesageHandlerService } from '@core/service/http-mesage-handler';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private authManagement: AuthManagementService,
    private router: Router,
    private httpMsgHandler: HttpMesageHandlerService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {

        const url = (request?.url ?? '').toLowerCase();
        const isLogin = url.includes('/auth/login');
        const isRenew = url.includes('/auth/renew');

        let backendError: any = err.error;
        if (typeof backendError === 'string' && backendError.startsWith('{"code":')) {
          try {
            backendError = JSON.parse(backendError);
          } catch {
          }
        }

        if (
          isLogin &&
          backendError &&
          typeof backendError === 'object' &&
          (backendError.code === 10050 || backendError.code === 22009 || backendError.code === 970005)
        ) {
          return of(
            new HttpResponse({
              status: 200,
              body: backendError,
              headers: err.headers,
              url: err.url ?? undefined,
            })
          );
        }

        if (err.error === 'Unknown relation type.') {
          return next.handle(request);
        }

        if (
          err.status === 404 &&
          err.statusText === 'OK' &&
          err.error?.message?.startsWith('No se encontraron')
        ) {
          return throwError(() => err);
        }

        if (typeof err.error === 'string' && err.error.startsWith('{"code":')) {
          try {
            backendError = JSON.parse(err.error);
          } catch {
          }
        }

        if (this.isDuplicatedRequestError(err, backendError)) {
          return EMPTY;
        }

        if (this.authManagement.isExpiredSessionLogoutInProgress()) {
          return throwError(() => err);
        }

        if (
          backendError &&
          typeof backendError === 'object' &&
          ('code' in backendError || 'toast' in backendError)
        ) {
          this.httpMsgHandler.handleMsg(backendError);
          return throwError(() => err);
        }

        if (isRenew) {
          return throwError(() => err);
        }

        this.httpMsgHandler.showUnexpectedErrorAlert();

        if (err.status === 401 && !window.location.href.includes('/authentication/')) {
          this.authManagement.logout();
          this.router.navigate(['/authentication/signin']).then();
        }

        return throwError(() => err);
      })
    );
  }

  private isDuplicatedRequestError(err: HttpErrorResponse, backendError: any): boolean {
    const backendCode = Number(backendError?.code);
    const backendMessage = String(backendError?.message ?? '').toUpperCase();
    const backendDescription = Array.isArray(backendError?.descripcion)
      ? backendError.descripcion.join(' ').toUpperCase()
      : String(backendError?.descripcion ?? '').toUpperCase();

    return (
      err.status === 429 ||
      backendCode === 42900 ||
      backendMessage.includes('PETICION_DUPLICADA') ||
      backendDescription.includes('PETICION_DUPLICADA')
    );
  }
}
